import { LicenseInfo } from '@mui/x-license'

/**
 * MUI X（DataGrid Pro / DatePickers Pro）のライセンスキー。
 *
 * キーは apps/web/.env の VITE_MUI_X_LICENSE_KEY に置く（git 管理外）。
 * 未設定だと実行時に「MUI X: Missing license key.」の警告が出て、
 * DataGrid にウォーターマークが入る。
 *
 * ⚠️ 以前は patches/@mui__x-license.patch で検証処理を握り潰していたが、
 *    正規のキーを渡す方式（platinum-line と同じ）に変えたので patch は削除した。
 */
const licenseKey = import.meta.env.VITE_MUI_X_LICENSE_KEY

if (licenseKey) {
  LicenseInfo.setLicenseKey(licenseKey)
} else if (import.meta.env.DEV) {
  console.warn('VITE_MUI_X_LICENSE_KEY が未設定です。apps/web/.env に MUI X のライセンスキーを設定してください。')
}
